import React, {useState, useContext} from "react";

import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import SHA512 from "crypto-js/sha512";
import validate from "validate.js";

import logo from "assets/img/spindl_logo-xxxhdpi.png";
import {AuthContext} from "providers/Auth/AuthProvider.jsx";

import SpindlApi from "modules/spindl-api";


function Login ({...props}) {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');


    const emailProps = {
        onChange : 
            e => {setEmail({value:e.target.value})},
        type:"email",
        required:true
    }
    const passwordProps = {
        onChange : 
            e => {setPassword(e.target.value)},
        type:"password",
        required:true
    }
    const authManager = useContext(AuthContext);
    
    const submitForm = async (e)=>{
        e.preventDefault();

        //TODO: Add validation
        //console.log(validate.single(email, {presence: true, email: true}));
        
        //Encrypt password
        const encrpytedPassword = SHA512(password).toString();

        const handleNetworkError = (e)=>{
            //If not successful alert that something has gone wrong to try again, or contact admin
            console.error(e);
            alert("Opps, something has gone wrong. Please check your email and password and try again. If the issue persists, contact your admin");
        }
        
        try{
            //Sign In
            const response = await SpindlApi.signIn(
                {
                    data:{
                        email:email.value, 
                        password:encrpytedPassword
                    }
                });

            //Update state of Auth Provider
            authManager.signIn(response.data.auth);

        }catch(error){
            handleNetworkError(error);
        }
        

    }
        return (
        <div style={{maxWidth:"330px", margin:"auto"}}>
        <GridContainer  justify="center">
          <GridItem xs={12} sm={12} md={12}>
            <Card >
              <CardBody>
                <div style = {{marginTop: "20px",   width:"100%", textAlign:"center"}}>
                    <img style = {{height:"80px"}} src={logo}/>
                </div>
                
                <form onSubmit = {submitForm}>
                    <CustomInput 
                        labelText = "Email" 
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps = {emailProps}
                        type="email"
                        value={email}
                        
                        />
                    <CustomInput 
                        labelText = "Password" 
                        type="password"
                        inputProps = {passwordProps}
                        formControlProps={{
                            fullWidth: true
                        }}
                        />
                    <br /> <br />
                    <Button type="submit" style = {{width:"100%"}} color="success"  >Login</Button>
                </form>
              </CardBody>
              
            </Card>
          </GridItem>
        </GridContainer>
      </div>
        )  

}

Login.propTypes = {
    classes: PropTypes.object.isRequired
  };
  
export default withStyles(dashboardStyle)(Login);


// WEBPACK FOOTER //
// ./src/views/Login/Login.jsx